import { render, staticRenderFns } from "./AddConnection.vue?vue&type=template&id=54859efc&scoped=true"
import script from "./AddConnection.vue?vue&type=script&lang=ts"
export * from "./AddConnection.vue?vue&type=script&lang=ts"
import style0 from "./AddConnection.vue?vue&type=style&index=0&id=54859efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54859efc",
  null
  
)

export default component.exports